import { Button } from "components/button";
import { Text } from "components/text";
import { cn } from "utils";
import { MouseEvent } from "react";
import { ListItem } from "components/List/ListItem";

interface CopyableListItemProps {
  text: string;
  subtext?: string;
  index?: number;
  testId?: string;
  onCopy?: (text: string) => void;
  className?: string;
  copyLabel?: string;
  analyticsId?: string;
}

export const CopyableListItem = ({
  text,
  subtext,
  index,
  testId,
  onCopy,
  className,
  copyLabel = "Copy",
  analyticsId,
}: CopyableListItemProps) => {
  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation();
    if (onCopy) {
      onCopy(text);
    }
  };

  return (
    <ListItem className={className} testId={testId}>
      <div className="flex flex-row gap-x-2 min-w-0 flex-1">
        {index !== undefined && (
          <Text as="span" variant="subtle">
            {index}.
          </Text>
        )}
        <Text variant="body" className="shrink-0">
          {text}
        </Text>
        {subtext && (
          <div className="flex items-center min-w-0 flex-1">
            <Text variant="subtle" className="truncate">
              {subtext}
            </Text>
          </div>
        )}
      </div>

      {onCopy && (
        <Button
          variant="ghost"
          icon="copy"
          size="small"
          onClick={handleCopy}
          aria-label={copyLabel}
          analyticsId={analyticsId}
          className={cn("opacity-0 group-hover:opacity-100 transition-opacity")}
        />
      )}
    </ListItem>
  );
};
